import { msalInstance } from "../index";
import { authConfig as msalConfig } from "../authconfig";

export const ApiScope = {
  scopes: [`${msalConfig.auth.clientId}/.default`],
};

const _getAccessToken = async (scopes: any, account: any) => {
  const response = await aquireAccessToken(scopes, account);
  return response.accessToken;
};

async function aquireAccessToken(scopes: any, account: any) {
  if (!account) {
    throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
  }

  const response = await msalInstance.acquireTokenSilent({
    ...scopes,
    account: account,
  });
  return response;
}

export const getUserId = () => {
  const account = msalInstance.getActiveAccount();
  return account?.localAccountId;
};

export const getAccessToken = async (scopes: any) => {
  const account = msalInstance.getActiveAccount();
  return await _getAccessToken(scopes, account);
};

export const getTenantId = () => {
  const account = msalInstance.getActiveAccount();
  return account?.tenantId;
};

export const getHeaders = async (scopes: any, headers: any) => {
  const account = msalInstance.getActiveAccount();
  const token = await _getAccessToken(scopes, account);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  /*if (account) {
        headers.set('X-OQ-TENANTID', account.tenantId);
    }*/

  return headers;
};

export const getRoles = (): string[] | undefined => {
  const account = msalInstance.getActiveAccount();
  return account?.idTokenClaims?.roles;
};

export const hasRole = (role: string): boolean => {
  return getRoles()?.find((v) => v === role) !== undefined;
};
